import { HeadlineProps } from '@awazevr/design-system.components.text'
import { IPropertyCard } from '@awazevr/design-system.compositions.property-card'
import { PropertyStackOrCarousel } from 'src/components/PropertyStackOrCarousel/PropertyStackOrCarousel'
import { FC } from 'react'

export interface CarouselModuleProps {
  title: string | HeadlineProps
  query: string
  buttonText: string
  numberOfCards: number
  properties: Omit<IPropertyCard, 'translations'>[]
  hasVerticalSpacing: boolean
  showAsCarousel: boolean | undefined
}

const mapProperty = (
  property: Omit<IPropertyCard, 'translations'>,
): Omit<IPropertyCard, 'translations'> => {
  return {
    isResponsive: false,
    bathrooms: property.bathrooms,
    bedrooms: property.bedrooms,
    code: property.code,
    features: property.features,
    guests: property.guests,
    hasCallout: property.hasCallout,
    hasPetsFree: property.hasPetsFree,
    images: property.images,
    location: property.location,
    nights: property.nights,
    pets: property.pets,
    price: property.price,
    priceFrom: property.priceFrom,
    rhs3: property.rhs3,
    score: property.score,
    startDate: property.startDate,
    title: property.title,
    USPs: property.USPs,
    wasPrice: property.wasPrice,
    grade: property.grade,
    pageURL: property.pageURL,
    cardinality: property.cardinality,
  }
}

export const CarouselModule: FC<CarouselModuleProps> = ({
  title,
  query,
  buttonText,
  numberOfCards,
  properties,
  hasVerticalSpacing,
  showAsCarousel,
}) => {
  if (!properties || properties.length === 0) {
    return null
  }
  return (
    <PropertyStackOrCarousel
      title={title}
      query={query || ''}
      amountOfCards={numberOfCards}
      showAsCarousel={showAsCarousel}
      buttonText={buttonText}
      properties={properties.map((property) => mapProperty(property))}
      hasVerticalSpacing={hasVerticalSpacing}
    />
  )
}
